import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@vimeo/bokeh';
import { translate } from '@vimeo/i18n-runtime';

type Props = {
  isActive: boolean;
  setActive: (isActive: boolean) => void;
  isLoading: boolean;
  onShowClick: () => void;
};

export const ShowCommentsConfirmationModal = ({
  isActive,
  setActive,
  isLoading,
  onShowClick,
}: Props) => {
  return (
    <Modal isOpen={isActive} onClose={() => setActive(false)} isCentered size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalHeader>{translate('Show comments on the video page')}</ModalHeader>
        <ModalBody>
          {translate(
            'Comments will be turned on in Appearance settings, making them visible to viewers on the video page',
          )}
        </ModalBody>
        <ModalFooter>
          <HStack>
            <Button variant="tertiary" onClick={() => setActive(false)}>
              {translate('Cancel')}
            </Button>
            <Button variant="primary" isLoading={isLoading} onClick={() => onShowClick()}>
              {translate('Show comments')}
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
